"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;
exports.integer = integer;
exports.string = string;
exports.email = email;
exports.min = min;
exports.max = max;
exports.date = date;
exports.before_or_equal = before_or_equal;
exports.after_or_equal = after_or_equal;
exports.required_if = required_if;
exports.credit_card_number = credit_card_number;
exports.credit_card_cvv = credit_card_cvv;
exports.credit_card_month = credit_card_month;
exports.credit_card_year = credit_card_year;
exports.length = length;

var _Console = require("./Console");

var _CreditCard = require("./../Classes/CreditCard");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function required(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return value !== '' && value !== null && typeof value !== 'undefined';
}

function integer(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Number.isInteger(parseInt(value));
}

function string(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return typeof value === 'string';
}

function email(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
  return re.test(value);
}

function min(value, arg) {
  if (_typeof(value) === 'object') return false;
  return parseInt(value) >= parseInt(arg);
}

function max(value, arg) {
  if (_typeof(value) === 'object') return false;
  return parseInt(value) <= parseInt(arg);
}

function date(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var date = new Date(value);
  return !isNaN(date.getFullYear()) && !isNaN(date.getMonth()) && !isNaN(date.getDate()) && date.toDateString() !== 'Invalid Date';
}

function before_or_equal(value, arg) {
  if (_typeof(value) === 'object' || _typeof(arg) === 'object' || typeof value === 'number' || typeof arg === 'number') return false;
  var originalDate = new Date(value);
  var comparingDate = new Date(arg);
  return originalDate.getTime() <= comparingDate.getTime();
}

function after_or_equal(value, arg) {
  if (_typeof(value) === 'object' || _typeof(arg) === 'object' || typeof value === 'number' || typeof arg === 'number') return false;
  var originalDate = new Date(value);
  var comparingDate = new Date(arg);
  return originalDate.getTime() >= comparingDate.getTime();
}

function required_if(value, arg) {
  if (typeof arg !== 'boolean') {
    (0, _Console.warn)('The value of required_if argument must be of type boolean.');
    (0, _Console.warn)('The required_if rule is ignored. Please fix its argument');
    return true;
  }

  return !arg ? true : required(value);
}

function credit_card_number(value, arg) {
  var cc = new _CreditCard.CreditCard(value, arg);
  return cc.isValid();
}

function credit_card_cvv(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var numberLength = 3;
  var regex = new RegExp("^[0-9]{".concat(numberLength, "}$"));
  return regex.test(value);
}

function credit_card_month(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return parseInt(value) <= 12 && parseInt(value) > 0;
}

function credit_card_year(value) {
  var arg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var currentYear = new Date().getFullYear().toString().substr(-2);
  return parseInt(value) >= parseInt(currentYear);
}

function length(value, arg) {
  return value.length === arg;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/utils/Rules.js
// module id = xuWw
// module chunks = 0 1